import { OutputDesignation } from '@ddt-web/config';
import { DateUtil, ModelNameUtil } from '@ddt-web/generic-utils';

import { ColumnConfig } from './column-config';
import { ColumnText } from './column-text';
import { StoreColumnExtractor, StoreLodashExtractor } from './extractors';
import { MapStoreExtractor } from './extractors/map-extractor';
import { SimpleExtractor } from './extractors/simple-extractor';
import { DateFormatter } from './formatters/date-formatter';
import { TabConfig } from './tab-config';

export class ComponentConfig {
	// TODO wdsdecom: Updated but check Component.portfolioNameColumn for all apps
	public static readonly PORTFOLIO_NAME_COLUMN = new ColumnConfig(
		null,
		null,
		new MapStoreExtractor(
			['associatedPortfolios', 'modelsConfig'], (associatedPortfolios, modelsConfig) => associatedPortfolios?.type ? associatedPortfolios.type : 'FALLBACK',
			{
				PORTFOLIO: new SimpleExtractor(['associatedPortfolios', 'modelsConfig'], (associatedPortfolios, modelsConfig) => {
					return associatedPortfolios?.description ?? '';
				}),
				MODEL_PORTFOLIO: new SimpleExtractor(['associatedPortfolios', 'modelsConfig'], (associatedPortfolios, modelsConfig) => {
					return ModelNameUtil.getModelName(modelsConfig, associatedPortfolios);
				}),
				THIRD_PARTY: new SimpleExtractor(['associatedPortfolios', 'modelsConfig'], (associatedPortfolios, modelsConfig) => {
					return ModelNameUtil.getModelName(modelsConfig, associatedPortfolios);
				}),
				FALLBACK: new StoreLodashExtractor(['associatedPortfolios'], 'description')
			}),
		'name'
	);

	public static readonly POSITION_DETAILS_PER_HOLDING_NAME_COLUMN = new ColumnConfig(
		null,
		null,
		new StoreLodashExtractor(['positionDetailsPerHolding'], 'ticker'),
		'ticker'
	);

	public static readonly DEFAULT_PORTFOLIO_COLUMNS = [
		new ColumnConfig(null, null, new StoreLodashExtractor(['details'], 'analysisDate'), 'asOfDate', new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)),
		new ColumnConfig(null, null, new StoreLodashExtractor(['details'], 'id'), 'id'), // actions drawer is failing because details call is failing - this id is used to populate designationsMap
		new ColumnConfig(null, null, new StoreLodashExtractor(['associatedPortfolios'], 'type'), 'portfolioType'),
		new ColumnConfig(null, null, new StoreLodashExtractor(['associatedPortfolios'], 'subType'), 'subType'),
		new ColumnConfig(null, null, new StoreLodashExtractor(['details'], 'aladdinTicker'), 'aladdinTicker'),
		ComponentConfig.PORTFOLIO_NAME_COLUMN,
		new ColumnConfig(
			null,
			null,
			new SimpleExtractor(['associatedPortfolios', 'details'], (associatedPortfolio, details) => {
				if (associatedPortfolio?.outputDesignation) {
					return associatedPortfolio.outputDesignation;
				} else if (associatedPortfolio && associatedPortfolio.portfolioType === 'MODEL_PORTFOLIO') {
					return OutputDesignation.MODEL;
				} else if (associatedPortfolio.applications?.includes('bfa.monitoring')) {
					return OutputDesignation.GLOBAL_COMPOSITE_BENCHMARK;
				} else {
					return OutputDesignation.USER_PORTFOLIO;
				}
			}),
			'outputDesignation'
		)
	];

	public static readonly DEFAULT_PORTFOLIO_COLUMNS_WITH_PORTKEY = [
		...ComponentConfig.DEFAULT_PORTFOLIO_COLUMNS,
		new ColumnConfig(null, null, new StoreLodashExtractor(['associatedPortfolios'], 'portKey'), 'portKey'),
		new ColumnConfig(new ColumnText('PORTFOLIO_BASE_MODEL_ID', 'Base Model Id'), null, new StoreLodashExtractor(['associatedPortfolios'], 'baseModel'), 'baseModel'),
		new ColumnConfig(null, null, new StoreLodashExtractor(['cohortBenchmarkDetail'], 'isBenchmark'), 'isBenchmark')
	];

	constructor(
		public readonly id: string,
		public readonly tabs: TabConfig[],
		public readonly portfolioDataExtractor: ColumnConfig<StoreColumnExtractor>[] = ComponentConfig.DEFAULT_PORTFOLIO_COLUMNS
	) { }

	public getTabById(id: string): TabConfig {
		const tabsById = this.tabs.filter(tab => tab.id === id);
		return tabsById.length ? tabsById[0] : null;
	}
	public getTabStartWithId(id: string): TabConfig[] {
		const tabsById = this.tabs.filter(tab => tab.id.startsWith(id));
		return tabsById;
	}
}
